<template>
    <va-create-layout>
        <CatalogItem-form :title="title" :item="item"></CatalogItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
